import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListPoliza from "./ListPoliza";
import ModalPoliza from "./components/ModalPoliza/ModalPoliza";
import { ReactiveBase, ReactiveList, DataSearch, MultiDropdownList, DateRange, SelectedFilters, ToggleButton } from "@appbaseio/reactivesearch";
import "moment/locale/es";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import _ from "lodash";
import "../../helperComponents/Elasticsearch/elasticsearch.scss";

var IndexPoliza = function IndexPoliza(props) {
  var admin = props.admin,
      token = props.token;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedPoliza = _React$useState2[0],
      setSelectedPoliza = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openModal = _React$useState4[0],
      setOpenModal = _React$useState4[1];

  var _React$useState5 = React.useState("updated_at"),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      sortField = _React$useState6[0],
      setSortField = _React$useState6[1];

  var _React$useState7 = React.useState("desc"),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      sortOrder = _React$useState8[0],
      setSortOrder = _React$useState8[1];

  var scrollPositionRef = React.useRef(0);

  var componentIds = function componentIds() {
    var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var filters = ['poliza_renewal', 'poliza_ramo', 'poliza_renewal_status_name', 'poliza_tipo_de_pago', 'poliza_company_name', 'poliza_nombre_contratante', 'poliza_nombre_asegurado', 'poliza_id', 'poliza_finish_date', 'poliza_substatus_clean', 'poliza_endorsement_status', 'poliza_preview_company_executive', 'created_at', 'updated_at', 'was_sent', 'sent_at'];
    return _.without(filters, except);
  };

  var defaultQuery = function defaultQuery() {
    return {
      timeout: "10s",
      query: {
        match_all: {}
      },
      size: 1
    };
  };

  var handleSort = function handleSort(field) {
    // Guardar la posición actual del scroll
    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop || window.scrollY;

    if (sortField === field) {
      // Si es el mismo campo, alternar entre asc y desc
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Si es un campo diferente, establecerlo y empezar con desc
      setSortField(field);
      setSortOrder("desc");
    }
  }; // Efecto para restaurar el scroll después de que se actualice el componente


  React.useEffect(function () {
    if (scrollPositionRef.current > 0) {
      // Usar múltiples intentos para asegurar que el scroll se restaure
      var restoreScroll = function restoreScroll() {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: 'auto' // Sin animación para que sea instantáneo

        });
      }; // Intentar restaurar inmediatamente


      restoreScroll(); // Intentar de nuevo después de que React haya actualizado el DOM

      requestAnimationFrame(function () {
        restoreScroll(); // Un intento más después de un pequeño delay para asegurar

        setTimeout(function () {
          restoreScroll();
        }, 50);
      });
    }
  }, [sortField, sortOrder]);

  var renderList = function renderList() {
    return /*#__PURE__*/React.createElement(ReactiveList, {
      componentId: "PolizasList" //highlight
      ,
      dataField: sortField,
      pagination: true,
      size: 50,
      loader: "Cargando resultados...",
      sortBy: sortOrder,
      showResultStats: true,
      react: {
        and: componentIds()
      },
      render: function render(_ref) {
        var data = _ref.data;
        return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
          style: {
            overflow: "auto"
          }
        }, data.id, /*#__PURE__*/React.createElement(ListPoliza, {
          polizas: data,
          onSelectedPoliza: onSelectedPoliza,
          admin: admin,
          token: token,
          sortField: sortField,
          sortOrder: sortOrder,
          onSort: handleSort
        }));
      }
    });
  };

  var onSelectedPoliza = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(poliza) {
      var polizaId, response, fullPolizaData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Abrir de inmediato el modal con los datos disponibles de Elasticsearch
              // para que el usuario vea la información al primer click.
              if (poliza) {
                setSelectedPoliza(poliza);
                setOpenModal(true);
              }

              _context.prev = 1;
              // Obtener datos completos de la póliza desde la base de datos (incluye agent_email_for_cc)
              polizaId = (poliza === null || poliza === void 0 ? void 0 : poliza.id) != null ? String(poliza.id) : "";
              _context.next = 5;
              return fetch("/admin/polizas/".concat(polizaId, "/modal_data.json"), {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "X-CSRF-Token": props.token
                },
                credentials: "same-origin"
              });

            case 5:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 13;
                break;
              }

              _context.next = 9;
              return response.json();

            case 9:
              fullPolizaData = _context.sent;
              setSelectedPoliza(fullPolizaData);
              _context.next = 14;
              break;

            case 13:
              console.error('Error obteniendo datos de la póliza:', response.statusText); // Si falla la petición, se mantiene la data ya mostrada en el modal

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.error('Error obteniendo datos de la póliza:', _context.t0); // Si hay error, se mantiene la data ya mostrada en el modal

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function onSelectedPoliza(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderOptions = function renderOptions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      componentId: "poliza_id",
      dataField: ["id_keyword", "code", "poliza_endorsements.id_keyword", "asegurado.rut", "contratante.rut", "beneficiario.rut", "asegurado.full_name", "contratante.full_name", "beneficiario.full_name", "item_asegurados.materia_asegurada", "item_asegurados.risk_address", "item_asegurados.patente"],
      queryFormat: "and",
      fuzziness: 2,
      title: "N\xBA propuesta, p\xF3liza, endoso o datos de contratante/beneficiario/asegurado, Materia o Direcci\xF3n asegurado o Patente",
      placeholder: "Buscar por n\xFAmero de propuesta, c\xF3digo de poliza, c\xF3digo del endoso o datos de contratante/beneficiario/asegurado" //defaultQuery={defaultQuery}
      ,
      autosuggest: false // somehow it crashes with this
      ,
      react: {
        and: componentIds("poliza_id")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_ramo",
      dataField: "ramo.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Ramo",
      title: "Ramo",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_ramo")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "renewal",
      dataField: "renewal",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Renovaci\xF3n",
      title: "Renovaci\xF3n?",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("poliza_renewal")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_renewal_status_name",
      dataField: "status_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Estado de la poliza",
      title: "Estado de la poliza",
      URLParams: false //loader="..."
      ,
      react: {
        and: componentIds("poliza_renewal_status_name")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_tipo_de_pago",
      dataField: "tipo_de_pago.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Forma de pago",
      title: "Forma de pago",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_tipo_de_pago")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_company_name",
      dataField: "company.name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Compa\xF1\xEDa",
      title: "Compa\xF1\xEDa",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_company_name")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "poliza_substatus_clean",
      dataField: "substatus_clean.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Sub-estado de la poliza",
      title: "Sub-estado de la poliza",
      URLParams: false //loader="..."
      ,
      react: {
        and: componentIds("poliza_substatus_clean")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_contratante",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery //dataField="poliza.document_data.nombre_contratante.keyword"
      ,
      dataField: "contratante.full_name.keyword" //nestedField="poliza.document_data"
      ,
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre contratante",
      title: "Contratante",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_contratante")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_nombre_asegurado",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "asegurado.full_name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Nombre Asegurado",
      title: "Asegurado",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_nombre_asegurado")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_endorsement_status",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "endorsement_status.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Estado de endosos",
      title: "Estado de endosos",
      URLParams: false //loader="Cargando..."
      ,
      react: {
        and: componentIds("poliza_endorsement_status")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      componentId: "poliza_finish_date",
      className: "col-md-4 elasticsearch-component" //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "finish_date",
      title: "Fecha de fin vigencia",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      componentId: "created_at",
      className: "col-md-4 elasticsearch-component" //defaultValue={{
      //  start: aYearAgo,
      //  end: today,
      //}}
      ,
      dataField: "created_at",
      title: "Fecha de creaci\xF3n",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      componentId: "poliza_preview_company_executive",
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      dataField: "preview_company_executive.keyword",
      showCount: true,
      showMissing: false,
      showSearch: true,
      showFilter: true,
      filterLabel: "Ejecutivo a Cargo",
      title: "Ejecutivo a Cargo",
      URLParams: false,
      transformData: function transformData(data) {
        return data.filter(function (item) {
          var key = item.key;
          return key !== null && key !== undefined && key !== "" && key !== "N/A" && typeof key === "string" && key.trim() !== "";
        });
      },
      react: {
        and: componentIds("poliza_preview_company_executive")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "updated_at",
      dataField: "updated_at",
      title: "Fecha de \xFAltima actualizaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "sent_at",
      dataField: "sent_at",
      title: "Fecha de env\xEDo",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha de env\xEDo",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds()
      }
    }), /*#__PURE__*/React.createElement(ToggleButton, {
      className: "col-md-4 elasticsearch-component clear-button",
      componentId: "was_sent",
      dataField: "was_sent",
      data: [{
        "label": "Sin enviar",
        "value": false
      }],
      filterLabel: "was_sent",
      multiSelect: false,
      showFilter: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(SelectedFilters, {
      className: "elasticsearch-component",
      showClearAll: true,
      clearAllLabel: "Limpiar filtros"
    })));
  };

  return /*#__PURE__*/React.createElement("div", null, selectedPoliza && /*#__PURE__*/React.createElement(ModalPoliza, {
    poliza: selectedPoliza,
    open: openModal,
    onClose: function onClose() {
      setSelectedPoliza(null);
      setOpenModal(false);
    }
  }), /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "polizas",
    url: "".concat(process.env.SEGUROS_API_URL),
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, renderOptions()), renderList()));
};

export default IndexPoliza;